module.exports = __webpack_public_path__ + "static/card-section-2-d4169a9ffa70944aa606e7358f1b30ee.jpg";